import RegularText from '@/components/RegularText';
import { SETTING_TYPE } from '@/constants/enum';
import { handleSaveWidgetTextDetail, widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { Box, TextField } from '@shopify/polaris';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const HeaderTitle = () => {
  const { t } = useTranslation('translation');
  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const pickupText = widgetTextDetail?.texts?.find((text) => text.type === SETTING_TYPE.PICKUP);
  const dispatch = useDispatch();

  const handleChangeTranslation = useCallback(
    (key: string, value: string) => {
      dispatch(
        handleSaveWidgetTextDetail({
          texts: widgetTextDetail?.texts?.map((text) => {
            if (text.type === SETTING_TYPE.PICKUP) {
              return {
                ...text,
                labelAndButtons: {
                  ...text.labelAndButtons,
                  [key]: value,
                },
              };
            }
            return text;
          }),
        }),
      );
    },
    [dispatch, widgetTextDetail],
  );

  return (
    <Box>
      <RegularText fontWeight="medium">Header title</RegularText>
      <TextField
        label={t('cartPage.pickup.headerLabel')}
        value={pickupText?.labelAndButtons?.buttonLabel}
        onChange={(value: string) => handleChangeTranslation('buttonLabel', value)}
        autoComplete="off"
      />
    </Box>
  );
};
